// extracted by css-extract-rspack-plugin
export default {"tooltip":"tooltip-dFpy2z"};